import { createContext, Dispatch, ReactNode, useContext, useReducer } from 'react';
import { IPageStatus } from './config/IPageStatus';
import React from 'react';

export interface ProductState {
    pageStatus: IPageStatus;
}

type ProductAction = {
    type: string;
    payload: any;
};

const initState: ProductState = {
    pageStatus: IPageStatus.STAGE_1,
};

const fsReducer = (state: ProductState, action: ProductAction): ProductState => {
    const { type, payload } = action;
    switch (type) {
        case 'changePageStatus':
            return { ...state, pageStatus: payload };
        default:
            return state;
    }
};

export const ProductContext = createContext<{ state: ProductState; dispatch: Dispatch<ProductAction> }>({
    state: initState,
    dispatch: () => null,
});

export function ProductProvider({ children, pageStatus }: { children: ReactNode; pageStatus: IPageStatus }) {
    const [state, dispatch] = useReducer(fsReducer, { ...initState, pageStatus });
    return React.createElement(ProductContext.Provider, {
        value: { state, dispatch },
        children,
    });
}

export const useProduct = () => {
    const context = useContext(ProductContext);
    return context;
};

export const useProductState = () => {
    const { state } = useProduct();
    return state;
};

export const useProductDispatch = () => {
    const { dispatch } = useProduct();
    return dispatch;
};
